import React, { Suspense } from 'react'
import { useLocation } from 'react-router'
import { useMount } from 'react-use'

import AppHeader from '@/components/layouts/DashboardLayout/components/DashboardSidebar/components/AppHeader'
import DashboardSidebar from '@/components/layouts/DashboardLayout/components/DashboardSidebar/DashboardSidebar'
import DashboardSidebarProvider from '@/components/layouts/DashboardLayout/components/DashboardSidebar/DashboardSidebarProvider'
import Footer from '@/components/layouts/DashboardLayout/components/Footer'
import PageContent from '@/components/misc/PageContent'
import SentryErrorBoundary from '@/components/misc/SentryErrorBoundary'
import { SidebarInset } from '@/components/ui/sidebar'
import LoadingWidget from '@/components/widgets/LoadingWidget'
import useAppDispatch from '@/hooks/useAppDispatch'
import { useNetworkDashboardSidebarLinks } from '@/hooks/useNetworkDashboardSidebarLinks'
import { LAYOUTS, setLayout } from '@/redux/slices/layout'

interface Props {
  children: React.ReactNode
  padded?: boolean
}

const NetworkDashboardLayout: React.FC<Props> = ({
  children,
  padded = true,
}) => {
  const location = useLocation()
  const sidebarLinks = useNetworkDashboardSidebarLinks()
  const dispatch = useAppDispatch()

  useMount(() => {
    dispatch(setLayout(LAYOUTS.networkDashboard))
  })

  return (
    <DashboardSidebarProvider>
      <DashboardSidebar links={sidebarLinks} />

      <SidebarInset className="min-w-0">
        <AppHeader />

        <PageContent padded={padded}>
          <SentryErrorBoundary key={location.pathname}>
            <Suspense fallback={<LoadingWidget />}>{children}</Suspense>
          </SentryErrorBoundary>
        </PageContent>

        <Footer />
      </SidebarInset>
    </DashboardSidebarProvider>
  )
}

export default NetworkDashboardLayout
